import React, { useState, useEffect } from "react";
import BanArrivals from "../Views/BanArrivals.jsx";
import moment from "moment";
import axios from "axios";

const Ban = (props) => {
    const defaultRules = [
        {
            id: 0,
            roomTypeId: null,
            forAllTypes: false,
            rateId: null,
            forAllRates: false,
            closeIn: false,
            closeOut: false,
            dateCloseStart: moment().format("YYYY-MM-DD"),
            dateCloseEnd: moment().add(1, "d").format("YYYY-MM-DD"),
        },
    ];

    const [rulesForChange, setRulesForChange] = useState(
        defaultRules.concat(props.banArrivals),
    );

    useEffect(() => {
        if (props.initAction) {
                props.initAction({}, 'banArrivals');
        }
    }, [props.initAction]);

    useEffect(() => {
        setRulesForChange(defaultRules.concat(props.banArrivals))
    }, [props.banArrivals]);

    const deleteBan = (id) => {
        axios
            .post(
                "/manager/data/hotels/" + props.hotelId + "/banArrivals/delete",
                { id: id },
            )
            .then(() => {
                props.initAction({}, 'banArrivals')
            })
            .catch((error) => alert(error));
    };

    const addBan = (e) => {
        e.preventDefault();
        let data = {};

        for (let [k, v] of Object.entries(e.target)) {
            if (k === "0") data.roomTypeId = v.value;
            if (k === "1") data.forAllTypes = v.checked;
            if (k === "2") data.rateId = v.value;
            if (k === "3") data.forAllRates = v.checked;
            if (k === "4") data.closeIn = v.checked;
            if (k === "5") data.closeOut = v.checked;
            if (k === "6") data.dateCloseStart = v.value;
            if (k === "7") data.dateCloseEnd = v.value;
        }

        const alertArr = [];
        if (data.dateCloseStart === "") alertArr.push("Укажите дату начала!");
        if (data.dateCloseEnd === "") alertArr.push("Укажите дату окончания!");
        if (data.rateId === "") alertArr.push("Выберите хотя бы один тариф");
        if (data.roomTypeId === "") alertArr.push("Выберите хотя бы одну категорию");
        if (!data.closeIn && !data.closeOut)
            alertArr.push("Задайте опцию запрета заезда или выезда!");

        if (alertArr.length > 0) {
            alert(alertArr.join("\n"));
            return;
        }

        const els = document.getElementsByClassName("banElement");
        data.id = Number(els[els.length - 1].id) + 1;

        axios
            .post(
                "/manager/data/hotels/" + props.hotelId + "/banArrivals/create",
                { data: data },
            )
            .then(() => props.initAction({}, 'banArrivals'))
            .catch((error) => alert(error));
    };

    return (
        <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-start",
            }}
        >
            {rulesForChange.map((banEl, idx) => (
                <div
                    key={banEl?.id}
                    className="banElement"
                    id={banEl?.id}
                    style={{
                        border: "5px solid grey",
                        borderRadius: "10px",
                        margin: "40px 40px",
                    }}
                >
                    <BanArrivals
                        deleteBan={deleteBan}
                        addBan={addBan}
                        key={banEl?.id}
                        id={banEl?.id}
                        rates={props.rates}
                        roomTypes={props.roomTypes}
                        data={banEl}
                    />
                </div>
            ))}
        </div>
    );
};

export default Ban;
